var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 12,
    viewBox: "0 0 6 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 6L5.85355 6.35355C6.04882 6.15829 6.04882 5.84171 5.85355 5.64645L5.5 6ZM0.146446 10.6464C-0.0488162 10.8417 -0.0488162 11.1583 0.146446 11.3536C0.341708 11.5488 0.658291 11.5488 0.853553 11.3536L0.146446 10.6464ZM0.853553 0.646446C0.658291 0.451184 0.341709 0.451184 0.146447 0.646446C-0.0488157 0.841709 -0.0488157 1.15829 0.146447 1.35355L0.853553 0.646446ZM5.14645 5.64645L0.146446 10.6464L0.853553 11.3536L5.85355 6.35355L5.14645 5.64645ZM0.146447 1.35355L5.14645 6.35355L5.85355 5.64645L0.853553 0.646446L0.146447 1.35355Z",
    fill: "#979797"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.4547fb572ad45a4b6702ded30805a978.svg";
export { ForwardRef as ReactComponent };